import React, { useState, ReactNode, Children, isValidElement } from 'react';
import lightStyles from './portalStylesLight.module.css';
import darkStyles from './portalStylesDark.module.css';

const tabs = ['Codes', 'Presences', 'Globals', 'Vip', 'Users', 'Queues'] as const;
type Tab = typeof tabs[number];

interface PortalFrameProps {
  children: ReactNode;
  lightMode: boolean;
  isSuperAdmin: boolean;
  hasAccountCodes: boolean;
  hasDispositionCodes: boolean;
  showVip: boolean;
}

interface TabComponentProps {
  tab: Tab;
  children: ReactNode;
}

export function TabComponent({ children, tab }: TabComponentProps) {
  return <>{children}</>;
}

export default function PortalFrame({
  children,
  lightMode,
  isSuperAdmin,
  hasAccountCodes,
  hasDispositionCodes,
  showVip,
}: PortalFrameProps) {
  const [activeTab, setActiveTab] = useState<Tab>('Codes');

  const styles = lightMode ? lightStyles : darkStyles;

  // Find the active child component
  const activeChild = Children.toArray(children).find((child) => {
    if (isValidElement(child) && child.type === TabComponent) {
      return child.props.tab === activeTab;
    }
    return false;
  });

  const doesDisplay = (tab: Tab) => {
    switch (tab) {
      case 'Users':
        return isSuperAdmin ? '' : 'none';
      case 'Codes':
        return hasAccountCodes || hasDispositionCodes ? '' : 'none';
      case 'Vip':
        return showVip ? '' : 'none';
      default:
        return '';
    }
  };

  return (
    <div className={styles.tabContainer}>
      <aside className={styles.sidebar}>
        {tabs.map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() => setActiveTab(tab)}
            className={styles.tabButton + (activeTab === tab ? ` ${styles.tabButtonActive}` : '')}
            style={{ display: doesDisplay(tab) }}
          >
            {tab}
          </button>
        ))}
      </aside>

      <main className={styles.content}>{activeChild /* only the active one ever gets rendered */}</main>
    </div>
  );
}
